// APP Config
export const SET_APP_CONFIG = 'SET_APP_CONFIG';

// account
export const SIGN_IN = 'SIGN_IN';
export const SIGN_IN_MVPD = 'SIGN_IN_MVPD';
export const SIGN_OUT = 'SIGN_OUT';
export const PENDING_SIGN_OUT = 'PENDING_SIGN_OUT';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const FETCHING_USER = 'FETCHING_USER';

// plans
export const GET_PLANS_REQUEST = 'GET_PLANS_REQUEST';
export const GET_PLANS_SUCCESS = 'GET_PLANS_SUCCESS';
export const SELECT_PLAN = 'SELECT_PLAN';
export const CLEAR_PLANS = 'CLEAR_PLANS';
export const CLEAR_SELECTED_PLAN = 'CLEAR_SELECTED_PLAN';
export const DISABLE_FREE_PROMO = 'DISABLE_FREE_PROMO';
export const DISABLE_DEFAULT_PROMO = 'DISABLE_DEFAULT_PROMO';

// layouts
export const UPDATE_PRIMARY_FOOTER = 'UPDATE_PRIMARY_FOOTER';
export const SET_HEADER_CLOSE = 'SET_HEADER_CLOSE';
export const SET_APP_LOADING = 'SET_APP_LOADING';

// checkout
export const UPDATE_TAX = 'UPDATE_TAX';
export const RESET_TAX = 'RESET_TAX';
export const TAX_UNAVAILABLE = 'TAX_UNAVAILABLE';
export const UPDATE_SHIPPING_ADDRESS = 'UPDATE_SHIPPING_ADDRESS';
export const RESET_SHIPPING_ADDRESS = 'RESET_SHIPPING_ADDRESS';
export const UPDATE_PAYMEMT_ACCOUNT_SUCCESS = 'UPDATE_PAYMEMT_ACCOUNT_SUCCESS';
export const SUCCESSFUL_PAYMENT = 'SUCCESSFUL_PAYMENT';
export const CLEAR_CHECKOUT = 'CLEAR_CHECKOUT';

// Overlay
export const SHOW_OVERLAY = 'SHOW_OVERLAY';
export const HIDE_OVERLAY = 'HIDE_OVERLAY';

// Tracking
export const SET_SOURCE = 'SET_SOURCE';
export const ANALYTICS_SET_PAGE_SOURCE = 'ANALYTICS_SET_PAGE_SOURCE';
export const ANALYTICS_SET_PAGE_NAME = 'ANALYTICS_SET_PAGE_NAME';
export const ANALYTICS_SET_PURCHASE_SOURCE = 'ANALYTICS_SET_PURCHASE_SOURCE';

// Integrations
export const SET_BANGO = 'SET_BANGO';
export const CLEAR_BANGO = 'CLEAR_BANGO';
export const SET_INITIAL_SHEER_STEP = 'SET_INITIAL_SHEER_STEP';
export const SET_REDIRECT_URL = 'SET_REDIRECT_URL';

// FreeForm
export const UPDATE_SCREEN = 'UPDATE_SCREEN';

// Entitlements
export const UPDATE_ENTITLEMENTS = 'UPDATE_ENTITLEMENTS';
export const CLEAR_ENTITLEMENTS = 'CLEAR_ENTITLEMENTS';

// promo coupon
export const SET_PROMO_CODE = 'SET_PROMO_CODE';
export const INVALID_PROMO_CODE = 'INVALID_PROMO_CODE';
export const RESET_PROMO_CODE = 'RESET_PROMO_CODE';
export const RESET_APPLIED_STATE = 'RESET_APPLIED_STATE';
export const SET_EMAIL_COUPON = 'SET_EMAIL_COUPON';
export const APPLY_EMAIL_COUPON = 'APPLY_EMAIL_COUPON';

// purchase mode
export const UPDATE_PURCHASE_MODE = 'UPDATE_PURCHASE_MODE';
export const UPDATE_CONFIRMATION_SUCCESS = 'UPDATE_CONFIRMATION_SUCCESS';
export const CLEAR_CONFIRMATION = 'CLEAR_CONFIRMATION';

// get payment history
export const GET_PAYMENT_REQUEST = 'GET_PAYMENT_REQUEST';
export const GET_PAYMENT_SUCCESS = 'GET_PAYMENT_SUCCESS';
export const GET_PAYMENT_ERROR = 'GET_PAYMENT_ERROR';
export const CLEAR_PAYMENT_HISTORY = 'CLEAR_PAYMENT_HISTORY';

// get payment methods
export const GET_PAYMENT_METHOD_REQUEST = 'GET_PAYMENT_METHOD_REQUEST';
export const GET_PAYMENT_METHOD_SUCCESS = 'GET_PAYMENT_METHOD_SUCCESS';
export const GET_PAYMENT_METHOD_ERROR = 'GET_PAYMENT_METHOD_ERROR';

// clear payment methods
export const CLEAR_PAYMENT_METHODS = 'CLEAR_PAYMENT_METHODS';
export const SET_PAYPAL_ERROR = 'SET_PAYPAL_ERROR';

// subscriptions
export const SUBSCRIPTION_REQUEST = 'SUBSCRIPTION_REQUEST';
export const SUBSCRIPTION_SUCCESS = 'SUBSCRIPTION_SUCCESS';
export const SUBSCRIPTION_ERROR = 'SUBSCRIPTION_ERROR';
export const SUBSCRIPTION_STATUS_SUCCESS = 'SUBSCRIPTION_STATUS_SUCCESS';
export const CLEAR_SUBSCRIPTION = 'CLEAR_SUBSCRIPTION';

// Second Screen
export const SET_SECOND_SCREEN = 'SET_SECOND_SCREEN';
export const RESET_SECOND_SCREEN = 'RESET_SECOND_SCREEN';
